import { render, staticRenderFns } from "./ProgramsSubheader.vue?vue&type=template&id=24fe9248&scoped=true&"
import script from "./ProgramsSubheader.vue?vue&type=script&lang=js&"
export * from "./ProgramsSubheader.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsSubheader.vue?vue&type=style&index=0&id=24fe9248&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe9248",
  null
  
)

export default component.exports